import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Construction } from 'lucide-react'

interface ComingSoonDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  featureName: string
  description?: string
}

/**
 * Placeholder dialog for features that are not yet implemented
 *
 * @example
 * ```tsx
 * const [showCaseDialog, setShowCaseDialog] = useState(false)
 *
 * <Button onClick={() => setShowCaseDialog(true)}>
 *   Open Case
 * </Button>
 *
 * <ComingSoonDialog
 *   open={showCaseDialog}
 *   onOpenChange={setShowCaseDialog}
 *   featureName="Case Management"
 *   description="Create and track support cases"
 * />
 * ```
 */
export function ComingSoonDialog({
  open,
  onOpenChange,
  featureName,
  description,
}: ComingSoonDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="rounded-full bg-muted p-3">
              <Construction className="h-6 w-6 text-muted-foreground" />
            </div>
          </div>
          <DialogTitle className="text-center">{featureName}</DialogTitle>
          <DialogDescription className="text-center">
            {description || 'This feature is coming soon. Check back later!'}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center mt-4">
          <Button onClick={() => onOpenChange(false)}>
            Got it
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
